import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Default api: uses admin token
export const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pn_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Client API: uses client token (different storage key)
export const clientApi = axios.create({ baseURL: API });
clientApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("pn_client_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
